import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { App } from "./App"
import "./assets/style/App.scss"

const appContainer = document.getElementById("root")
if (appContainer === null) {
	throw new Error("Unable to find app container root")
}

const root = createRoot(appContainer)

root.render(
	<React.StrictMode>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</React.StrictMode>
)

// Older releases registered a service worker; remove any that remain so
// returning visitors aren't served a cached copy of the old app.
if ("serviceWorker" in navigator) {
	navigator.serviceWorker
		.getRegistrations()
		.then(registrations => registrations.forEach(r => r.unregister()))
		.catch(() => undefined)
}
